import * as accountApi from '@/network/api/accounts.api.js'

/** Generates an Extract for user to consult
@payload {Object}
@return {promise}
*/
export const generateExtract = async (context, payload) => {
    const res = await accountApi.generateExtract(payload)
    return res
}

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
/** Clear states
@return { promise }
*/
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
